module.exports = __webpack_public_path__ + "media/images/girl-in-sofa-84b23ce6f9fa2d63c429b86c2c9b5f30.svg";